import { Box, Select as CSelect, Flex, Icon, Text } from '@chakra-ui/react'
import { AiOutlineCheck } from 'react-icons/ai'
import React from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'
import { ErrorMessage } from './error-message'

type Props = {
  isValid: boolean
  isError?: boolean
  label: string
  id: string
  formHook: UseFormRegisterReturn
  value?: string
  flex?: number
  options: { label: string; value: string }[]
}

export const Select = ({ id, label, isValid, flex, isError, formHook, value, options }: Props) => {
  return (
    <Box flex={flex} mb="2rem">
      <Box w="100%" pos="relative">
        <CSelect
          sx={{
            '&:focus + label': {
              top: 0,
              color: '#4D80E4'
            }
          }}
          icon={isValid ? <Icon as={AiOutlineCheck} marginRight="2rem" /> : undefined}
          id={id}
          iconSize="20"
          iconColor="brand.successBlue"
          w="100%"
          h="5.6rem"
          fontSize="1.4rem"
          pos="relative"
          borderColor={isError ? 'brand.red' : isValid === true ? 'brand.successBlue' : '#DDDDDD'}
          borderRadius="1rem"
          _hover={{ border: '1px solid #4D80E4' }}
          _focus={{ border: '1px solid #4D80E4' }}
          {...formHook}>
          {/* <option disabled value="">
            {label}
          </option> */}
          {options.map((option) => (
            <Text as="option" value={option.value}>
              {option.label}
            </Text>
          ))}
        </CSelect>

        <Text
          as="label"
          htmlFor={id}
          pos="absolute"
          top={value ? 0 : '50%'}
          left="1.5rem"
          transform="translateY(-50%)"
          bg="#fff"
          color={isError ? 'brand.red' : isValid === true ? 'brand.successBlue' : ''}
          pointerEvents="none"
          transition="all 0.3s"
          fontSize="1.25rem"
          px="5px">
          {label}
        </Text>
      </Box>
      <ErrorMessage isError={isError} />
    </Box>
  )
}
